import COLORS from '@/constants/colors';
import { appVersion } from '@/constants/environment';
import { useGlobalContext } from '@/context/Global/GlobalContext';
import { DashboardUserType } from '@/utils/enums';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function VersionBadge() {
  const { session } = useGlobalContext();
  const isAdmin = session?.type === DashboardUserType.ADMIN;
  const UserIcon = isAdmin ? PeopleAltIcon : StorefrontIcon;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        mt: 2,
        mb: 4,
        borderRadius: '16px',
        border: `1px solid ${COLORS.green_200}`,
        backgroundColor: COLORS.green_100,
        px: 1,
        width: 'fit-content',
        alignSelf: 'center',
      }}
    >
      <UserIcon sx={{ color: COLORS.adminGreen, width: 14, height: 14 }} />
      <Typography
        fontSize={12}
        fontWeight={500}
        textAlign="center"
        color={COLORS.adminGreen}
      >
        {isAdmin ? 'Admin ' : 'Vendedores '}
        <Typography component="span" fontSize={12} fontWeight={700}>
          {appVersion}
        </Typography>
      </Typography>
    </Box>
  );
}
